/* Bali home: hero slider (crossfade + autoplay), product rails, scroll reveal, AJAX quick add. No libraries. */
(function () {
  // every bali-home section includes this file; run it only once per page
  if (window.__bhHomeLoaded) return;
  window.__bhHomeLoaded = true;
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var root = document.documentElement;

  /* ---------- Hero ---------- */
  function initHero(hero) {
    if (hero.__bhInit) return;
    hero.__bhInit = true;
    var slides = hero.querySelectorAll('[data-bh-slide]');
    var dots = hero.querySelectorAll('[data-bh-dot]');
    var delay = parseInt(hero.getAttribute('data-autoplay'), 10) || 0;
    if (reduceMotion || (window.Shopify && Shopify.designMode)) delay = 0;
    var current = 0, timer = null, paused = false;

    function go(i) {
      current = (i + slides.length) % slides.length;
      slides.forEach(function (s, n) {
        var on = n === current;
        s.classList.toggle('is-active', on);
        if (on) s.removeAttribute('aria-hidden'); else s.setAttribute('aria-hidden', 'true');
        s.querySelectorAll('a, button').forEach(function (el) { if (on) el.removeAttribute('tabindex'); else el.setAttribute('tabindex', '-1'); });
        s.querySelectorAll('video').forEach(function (v) { try { if (on && !reduceMotion) v.play(); else v.pause(); } catch (err) {} });
      });
      dots.forEach(function (d, n) { d.setAttribute('aria-selected', n === current ? 'true' : 'false'); });
      restartFill();
      schedule();
      watchHeroCtas();
    }
    function restartFill() {
      dots.forEach(function (d) { d.classList.remove('is-active'); });
      if (dots[current]) {
        void dots[current].offsetWidth;
        dots[current].classList.add('is-active');
        var bar = dots[current].parentElement;
        if (bar && bar.scrollWidth > bar.clientWidth) bar.scrollTo({ left: dots[current].offsetLeft - 16, behavior: reduceMotion ? 'auto' : 'smooth' });
      }
    }
    function schedule() {
      clearTimeout(timer);
      if (delay && !paused && slides.length > 1) timer = setTimeout(function () { go(current + 1); }, delay);
    }
    function pause(on) {
      paused = on;
      hero.classList.toggle('is-paused', on);
      if (on) clearTimeout(timer); else { restartFill(); schedule(); }
    }
    if (delay && slides.length > 1) hero.classList.add('is-autoplay');
    dots.forEach(function (d) { d.addEventListener('click', function () { go(+d.getAttribute('data-bh-dot')); }); });
    var prevBtn = hero.querySelector('[data-bh-hero-prev]'), nextBtn = hero.querySelector('[data-bh-hero-next]');
    if (prevBtn) prevBtn.addEventListener('click', function () { go(current - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { go(current + 1); });
    hero.addEventListener('mouseenter', function () { pause(true); });
    hero.addEventListener('mouseleave', function () { pause(false); });
    hero.addEventListener('focusin', function () { pause(true); });
    hero.addEventListener('focusout', function () { pause(false); });

    var x0 = null, y0 = null;
    hero.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; pause(true); }, { passive: true });
    hero.addEventListener('touchend', function (e) {
      if (x0 !== null) {
        var dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0;
        if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) go(current + (dx < 0 ? 1 : -1));
      }
      x0 = null;
      setTimeout(function () { pause(false); }, 4000);
    }, { passive: true });
    hero.addEventListener('shopify:block:select', function (e) {
      var i = Array.prototype.indexOf.call(slides, e.target);
      if (i > -1) { pause(true); go(i); }
    });
    document.addEventListener('visibilitychange', function () { pause(document.hidden); });
    schedule();
  }

  /* hide the floating Webcam/WhatsApp buttons on mobile while the hero buttons are on screen */
  var ctaObserver = null;
  function watchHeroCtas() {
    if (!('IntersectionObserver' in window)) return;
    if (ctaObserver) ctaObserver.disconnect();
    var visible = new Set();
    ctaObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) visible.add(en.target); else visible.delete(en.target); });
      root.classList.toggle('bh-hero-ctas-visible', visible.size > 0);
    });
    document.querySelectorAll('.bh-hero__slide.is-active .bh-hero__ctas').forEach(function (el) { ctaObserver.observe(el); });
  }

  /* ---------- Product rails ---------- */
  function initRail(section) {
    if (section.__bhInit) return;
    section.__bhInit = true;
    var rail = section.querySelector('[data-bh-rail]');
    var prev = section.querySelector('[data-bh-prev]');
    var next = section.querySelector('[data-bh-next]');
    if (!rail) return;
    function step() {
      var slot = rail.querySelector('.bh-slot');
      var styles = window.getComputedStyle(rail);
      var gap = parseFloat(styles.columnGap || styles.gap) || 0;
      return slot ? slot.getBoundingClientRect().width + gap : rail.clientWidth * 0.8;
    }
    function update() {
      var max = rail.scrollWidth - rail.clientWidth - 2;
      if (prev) prev.disabled = rail.scrollLeft <= 2;
      if (next) next.disabled = rail.scrollLeft >= max;
    }
    if (prev) prev.addEventListener('click', function () { rail.scrollBy({ left: -step(), behavior: reduceMotion ? 'auto' : 'smooth' }); });
    if (next) next.addEventListener('click', function () { rail.scrollBy({ left: step(), behavior: reduceMotion ? 'auto' : 'smooth' }); });
    rail.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
    window.addEventListener('resize', update);
    update();

    /* slow continuous glide: time-based, eased, infinite (cloned cards), moves only the rail's scrollLeft */
    var mode = section.getAttribute('data-glide') || '';
    if (!mode || reduceMotion || (window.Shopify && Shopify.designMode)) return;
    // "solo en celular": desktop keeps the static rail with arrows
    if (section.hasAttribute('data-glide-mobile-only') && !window.matchMedia('(max-width: 749px)').matches) return;
    var slots = Array.prototype.slice.call(rail.querySelectorAll(':scope > .bh-slot'));
    if (slots.length < 2) return;
    slots.forEach(function (slot) {
      var c = slot.cloneNode(true);
      c.classList.add('bh-slot--clone', 'is-in');
      c.setAttribute('aria-hidden', 'true');
      c.removeAttribute('data-shopify-editor-block');
      c.querySelectorAll('a, button, input, select, textarea').forEach(function (el) { el.setAttribute('tabindex', '-1'); });
      c.querySelectorAll('[id]').forEach(function (el) { el.removeAttribute('id'); });
      rail.appendChild(c);
    });
    var firstClone = rail.querySelector('.bh-slot--clone');
    function loopWidth() { return firstClone.offsetLeft - slots[0].offsetLeft; }
    function target() {
      var mobile = window.matchMedia('(max-width: 749px)').matches;
      if (mode === 'slow') return mobile ? 10 : 14;
      return mobile ? 16 : 22;
    }
    var inView = false, hold = false, holdTimer = null, raf = null, last = 0, pos = 0, vel = 0;
    function frame(t) {
      raf = null;
      var goal = (inView && !hold && !document.hidden) ? target() : 0;
      var dt = last ? Math.min(t - last, 64) / 1000 : 0;
      last = t;
      vel += (goal - vel) * Math.min(1, dt / 0.13);
      if (goal === 0 && vel < 0.3) {
        vel = 0; last = 0;
        // keep snap off while merely paused so the rail never jumps to the nearest card; arrows restore it
        section.classList.remove('is-gliding');
        return;
      }
      var w = loopWidth();
      pos += vel * dt;
      if (w > 0 && pos >= w) pos -= w;
      rail.scrollLeft = pos;
      raf = requestAnimationFrame(frame);
    }
    function kick() {
      if (raf) return;
      if (!inView || hold || document.hidden) return;
      var w = loopWidth();
      pos = rail.scrollLeft;
      if (w > 0 && pos >= w) { pos -= w; rail.scrollLeft = pos; }
      rail.style.scrollSnapType = 'none';
      section.classList.add('is-gliding');
      last = 0;
      raf = requestAnimationFrame(frame);
    }
    function settle() { if (!raf && vel === 0) return; if (!raf) raf = requestAnimationFrame(frame); }
    function pause() { hold = true; clearTimeout(holdTimer); settle(); }
    function resumeLater(ms) {
      clearTimeout(holdTimer);
      holdTimer = setTimeout(function () { hold = false; kick(); }, ms);
    }
    rail.addEventListener('mouseenter', pause);
    rail.addEventListener('mouseleave', function () { resumeLater(3000); });
    rail.addEventListener('touchstart', pause, { passive: true });
    rail.addEventListener('touchend', function () { resumeLater(3000); }, { passive: true });
    rail.addEventListener('wheel', function () { pause(); resumeLater(3000); }, { passive: true });
    rail.addEventListener('focusin', pause);
    rail.addEventListener('focusout', function () { resumeLater(3000); });
    [prev, next].forEach(function (b) {
      if (!b) return;
      // capture phase: stop the glide (and restore snap) before the arrow's smooth one-card scroll runs
      b.addEventListener('click', function () {
        hold = true; clearTimeout(holdTimer);
        if (raf) cancelAnimationFrame(raf);
        raf = null; vel = 0; last = 0;
        rail.style.scrollSnapType = '';
        section.classList.remove('is-gliding');
        resumeLater(3000);
      }, true);
    });
    document.addEventListener('visibilitychange', function () { if (document.hidden) settle(); else kick(); });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        inView = entries[0].isIntersecting;
        if (inView) kick(); else settle();
      }, { threshold: 0.25 }).observe(rail);
    } else { inView = true; kick(); }
  }

  /* ---------- Scroll reveal (hidden state only exists once html.bh-reveal-on is set) ---------- */
  var revealObserver = null;
  function initReveal(scope) {
    if (reduceMotion || !('IntersectionObserver' in window) || (window.Shopify && Shopify.designMode)) return;
    root.classList.add('bh-reveal-on');
    if (!revealObserver) {
      revealObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          en.target.classList.add('is-in');
          revealObserver.unobserve(en.target);
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    }
    (scope || document).querySelectorAll('.bh-reveal:not(.is-in)').forEach(function (el) {
      var siblings = el.parentElement ? Array.prototype.filter.call(el.parentElement.children, function (c) { return c.classList.contains('bh-reveal'); }) : [el];
      var idx = siblings.indexOf(el);
      el.style.setProperty('--bh-delay', Math.min(idx, 8) * 60 + 'ms');
      revealObserver.observe(el);
    });
    // safety net: never leave content hidden
    setTimeout(function () { document.querySelectorAll('.bh-reveal:not(.is-in)').forEach(function (el) { var r = el.getBoundingClientRect(); if (r.top < window.innerHeight) el.classList.add('is-in'); }); }, 2500);
  }

  /* ---------- Lazy iframes (iVoox player): src only when near the viewport ---------- */
  function initLazyFrames() {
    var frames = document.querySelectorAll('iframe[data-bh-lazy-src]:not([src])');
    if (!frames.length) return;
    function load(f) { f.setAttribute('src', f.getAttribute('data-bh-lazy-src')); }
    if (!('IntersectionObserver' in window)) { frames.forEach(load); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { load(en.target); io.unobserve(en.target); } });
    }, { rootMargin: '600px 0px' });
    frames.forEach(function (f) { io.observe(f); });
  }

  function initAll(scope) {
    initLazyFrames();
    document.querySelectorAll('[data-bh-hero]').forEach(initHero);
    document.querySelectorAll('[data-bh-rail-section]').forEach(initRail);
    initReveal(scope);
    watchHeroCtas();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); }); else initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });

  /* ---------- Quick add ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('form[data-bh-add]');
    if (!form || (window.theme && window.theme.cartType === 'page')) return;
    e.preventDefault();
    var button = form.querySelector('[type="submit"]');
    if (button) button.setAttribute('disabled', 'disabled');
    document.dispatchEvent(new CustomEvent('theme:loading:start'));
    var url = ((window.routes && window.routes.cartAddUrl) || '/cart/add') + '.js';
    fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: form.querySelector('[name="id"]').value, quantity: 1 })
    }).then(function (response) {
      if (button) button.removeAttribute('disabled');
      if (response.ok) {
        form.dispatchEvent(new CustomEvent('product:added', { bubbles: true, detail: { button: button, variant: null, quantity: 1 } }));
      } else {
        document.dispatchEvent(new CustomEvent('theme:loading:end'));
        window.location.href = form.getAttribute('data-product-url') || '/cart';
      }
    }).catch(function () {
      if (button) button.removeAttribute('disabled');
      document.dispatchEvent(new CustomEvent('theme:loading:end'));
    });
  });
})();
